export default "__VITE_PUBLIC_ASSET__fd140564__"